import { useMutation } from '@tanstack/react-query';
import { rpcClient } from '@/api/rpc/client';

/**
 * Natural-language → Vega-Lite spec generation for the report canvas's
 * vega-chart widget. No cache interaction: the result feeds straight into the
 * component's config, never a query cache.
 */
export function useGenerateVegaSpec() {
  return useMutation({
    mutationFn: rpcClient.core.reportCanvasAi.generateVegaSpec,
  });
}
